/**
 * THE way to reach the floor-plan editor state: any component under the
 * editor root subscribes with useFloorPlanEditorState() — the state is never
 * passed through props.
 *
 * The editor's root component creates the state with
 * useCreateFloorPlanEditorState() and provides it through
 * FloorPlanEditorStateContext.Provider (the context object is exported —
 * rather than a provider component — so this package stays component-free;
 * web and React Native shells provide it from their own roots).
 */
import { createContext, useContext } from 'react';
import type { FloorPlanEditorState } from './FloorPlanEditorState';

export const FloorPlanEditorStateContext = createContext<FloorPlanEditorState | null>(null);

export function useFloorPlanEditorState(): FloorPlanEditorState {
  const floorPlanEditorState = useContext(FloorPlanEditorStateContext);
  if (!floorPlanEditorState) {
    throw new Error('useFloorPlanEditorState must be used inside a FloorPlanEditorStateContext.Provider');
  }
  return floorPlanEditorState;
}
